import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, HelpCircle } from 'lucide-react';
const faqs = [{
  question: '¿De qué trata exactamente "Mi Psicóloga Me Dijo"?',
  answer: 'Es una guía digital que reúne 130 razones y verdades profundas diseñadas para ayudarte a soltar el dolor del pasado, sanar tu historia y aprender a elegirte a ti misma sin culpa. Es un viaje de autodescubrimiento y amor propio.'
}, {
  question: '¿Es un libro físico o digital?',
  answer: 'Es un material 100% digital en formato PDF de alta calidad. Esto te permite recibirlo de forma inmediata en tu correo y leerlo desde cualquier dispositivo (celular, tablet o computadora), o incluso imprimirlo si lo prefieres.'
}, {
  question: '¿Cómo recibo los 6 libros de regalo?',
  answer: '¡Es muy simple! Una vez que realices la compra, recibirás un correo electrónico con un enlace de descarga único. Al hacer clic, podrás descargar tanto el libro principal como los 6 bonos de regalo de forma automática.'
}, {
  question: '¿Necesito estar en terapia para leerlo?',
  answer: 'No es necesario. Si bien este material no reemplaza un proceso terapéutico individual, está escrito en un lenguaje cercano y empático para que cualquier mujer pueda usarlo como una herramienta de auto-asistencia y reflexión diaria.'
}, {
  question: '¿Por cuánto tiempo tendré acceso al material?',
  answer: 'El acceso es de por vida. Una vez que descargas los archivos, son tuyos para siempre. Puedes volver a leer las 130 razones cada vez que necesites un recordatorio de tu valor.'
}, {
  question: '¿Es seguro el pago y qué pasa si no me gusta?',
  answer: 'Tu pago es totalmente seguro y está protegido. Además, confiamos tanto en el valor de este material que ofrecemos una garantía de satisfacción de 14 días. Si sientes que no es para ti, te devolvemos el dinero.'
}];
export function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  return <section className="py-24 pt-[30px] pb-[30px] bg-[#FEFEFE]" data-id="element-56">
      <div className="max-w-3xl mx-auto px-4 bg-[#FEFEFE]" data-id="element-57">
        <div className="text-center mb-16" data-id="element-58">
          <h2 className="text-violet-600 font-black uppercase tracking-[0.3em] mb-4 text-xs" data-id="element-59">
            DESPEJA TUS DUDAS
          </h2>
          <h3 className="text-4xl md:text-6xl text-violet-950 font-medium font-['Playfair_Display']" data-id="element-60">
            Preguntas Frecuentes
          </h3>
        </div>

        <div className="space-y-4" data-id="element-61">
          {faqs.map((faq, index) => <div key={index} className="border border-violet-100 rounded-2xl overflow-hidden transition-all duration-300 hover:border-violet-200" data-id="element-62">
              <button onClick={() => setActiveIndex(activeIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-violet-50/30 hover:bg-violet-50 transition-colors" data-id="element-63">
                <span className="font-bold text-violet-950 pr-8 leading-tight" data-id="element-64">
                  {faq.question}
                </span>
                <div className="shrink-0 text-violet-600" data-id="element-65">
                  {activeIndex === index ? <Minus size={20} data-id="element-66" /> : <Plus size={20} data-id="element-67" />}
                </div>
              </button>

              <AnimatePresence data-id="element-68">
                {activeIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-69">
                    <div className="p-6 pt-0 text-violet-800/80 leading-relaxed bg-violet-50/30" data-id="element-70">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}